// extracted by mini-css-extract-plugin
export default {"container":"styles_container__BC6xH","content":"styles_content__fUmT9","back_button":"styles_back_button__s96J5"};